import { call, put } from 'redux-saga/effects';
import GetAppointmentTimeslotsActions from '../redux/GetAppointmentTimeslotsRedux';
import { api } from './api';


export function* getAppointmentTimeslots(action: any): Generator<any, void, any> {
  const { categoryId } = action
  const response = yield call(api.getAppointmentTimeslots, categoryId);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetAppointmentTimeslotsActions.getAppointmentTimeslotsSuccess(response.data));
  } else {
    yield put(GetAppointmentTimeslotsActions.getAppointmentTimeslotsFailure());
  }
}